import { useTranslation } from "react-i18next";
import { Chip } from "@outpave/ds";
import type { ChipSize } from "@outpave/ds";
import RelationshipType from "../../../enums/RelationshipType";
import {
  relationshipLabelKey,
  relationshipTone,
} from "utils/contacts/relationship";

interface RenderRelationshipProps {
  relationship: RelationshipType | null | undefined;
  size?: ChipSize;
}

/**
 * One relationship pill for every surface that draws one, over the shared
 * label and tone maps in `relationship.ts`.
 *
 * No `StatusGlyph`: a relationship is what a contact IS, not a state it is in,
 * so it carries no dot or glyph the way `RenderUserStatus` does.
 */
export const RenderRelationship: React.FC<RenderRelationshipProps> = ({
  relationship,
  size = "sm",
}) => {
  const { t } = useTranslation();

  const labelKey = relationshipLabelKey(relationship);
  if (!labelKey) return null;

  return (
    <Chip tone={relationshipTone(relationship)} size={size}>
      {t(labelKey)}
    </Chip>
  );
};

export default RenderRelationship;
